import { RootState } from "@/store/store";
import { homeDashboardSelector } from "@/store/dashboards/selectors/home/homeDashboardSelector";

export const homeDashboardIdSelector = (state: RootState) => {
  const home = homeDashboardSelector(state);

  return home?.id;
};
